import React, { useState } from 'react';

import { EpisodeStatusLabel } from '../../../components/organisms';
import SvgLogoGray from '../../../../assets/svgs/logo-gray.svg';
import classNames from 'classnames/bind';
import style from './styles.module.scss';

const cx = classNames.bind(style);

const Card = ({
  coverImage,
  coverImageFormat,
  title = '',
  description = '',
  labeledItems = [],
  episodeStatus = '',
  buttonDescription = '',
  selected,
  onClick,
  onTitleClick,
  className,
  renderRight,
  renderBottom,
  renderAccordion,
  rejectHandler,
}) => {
  const [ballonOpen, setBallonOpen] = useState(
    buttonDescription !== '' && buttonDescription ? true : false,
  );
  const descripionBallon = (text) => {
    return (
      <div className={cx('ballon-container')} onClick={() => setBallonOpen(false)}>
        <div className={cx('ballon')}>
          {text}
          <img src={require('../../../../assets/ic-close@3x.png').default} alt="close-icon" />
        </div>
      </div>
    );
  };

  return (
    <div className={cx('Card')}>
      {ballonOpen && descripionBallon(buttonDescription)}
      <div
        className={cx('card-container', className, { selected })}
        onClick={onClick}
        style={{ cursor: onClick === undefined && 'default' }}
      >
        <div className={cx('card-image-container')}>
          {episodeStatus && (
            <EpisodeStatusLabel
              className={cx('naamezip-episode-status')}
              episodeStatus={episodeStatus}
            />
          )}
          {coverImage ? (
            <img
              className={cx('card-image')}
              src={`${coverImage}${coverImageFormat}`}
              alt="naamezip"
            />
          ) : (
            <div className={cx('card-empty-image')}>
              <SvgLogoGray />
            </div>
          )}
        </div>

        <div className={cx('naamezip-content-container')}>
          <div className={cx('naamezip-content')}>
            <div className={cx('naamezip-content-left')}>
              {episodeStatus === 'REJECTED_BY_ADMIN' && onTitleClick && (
                <button className={cx('reject-button')} onClick={rejectHandler}>
                  <div>!</div>수정요청 보기
                </button>
              )}
              <div className={cx('naamezip-content-main-text')} onClick={onTitleClick}>
                <h3
                  className={cx(
                    'naamezip-content-title',
                    episodeStatus === 'REJECTED_BY_ADMIN' && 'naamezip-content-title-rejected',
                  )}
                >
                  {title}
                </h3>
                <p className={cx('naamezip-content-description')}>{description}</p>
              </div>
              <div className={cx('naamezip-content-item-list')}>
                {labeledItems.map((item, index) => (
                  <div className={cx('naamezip-content-item')} key={index}>
                    <p className={cx('naamezip-content-item-label')}>{item.label}</p>
                    <p className={cx('naamezip-content-item-value')}>{item.value}</p>
                  </div>
                ))}
              </div>
            </div>
            {renderRight && <div className={cx('naamezip-render-right')}>{renderRight()}</div>}
          </div>
          {renderBottom && <div className={cx('naamezip-render-bottom')}>{renderBottom()}</div>}
        </div>
      </div>
      {renderAccordion && (
        <div className={cx('card-accordion', { selected })}>{renderAccordion()}</div>
      )}
    </div>
  );
};

export default Card;
